// Tiny ring buffer of the most recent N API response identifiers. The
// API stamps every response with `x-request-id` (uuidv7); when the user
// hits an error boundary we want to ship those ids back to the server so
// the on-call engineer can correlate the client crash with whatever the
// Worker was doing in the seconds before. Without this, /v1/client-errors
// reports are uncorrelated free-text and have to be hunted down manually.

const MAX_ENTRIES = 20;
const buffer: TraceEntry[] = [];

export interface TraceEntry {
  /** uuidv7 from the API's `x-request-id` response header. */
  request_id: string;
  /** Path the call hit, for context. */
  path: string;
  /** HTTP status — most useful when scanning for the failure that
   *  triggered the boundary. */
  status: number;
  /** Epoch ms when the response was received. */
  at: number;
}

export function recordResponse(path: string, res: Response): void {
  const requestId = res.headers.get("x-request-id");
  if (!requestId) return;
  buffer.push({ request_id: requestId, path, status: res.status, at: Date.now() });
  if (buffer.length > MAX_ENTRIES) buffer.shift();
}

export function getRecentRequestTrace(): TraceEntry[] {
  return buffer.slice();
}

/** Test-only — clears the ring. Not exported from the public api barrel. */
export function _resetRequestTrace(): void {
  buffer.length = 0;
}
